import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex items-center justify-between py-4 pl-4 pr-4 rounded" }
const _hoisted_8 = { class: "flex flex-col h-full" }
const _hoisted_9 = { class: "flex-1 overflow-auto" }
const _hoisted_10 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_11 = { class: "formcontainer flex flex-col" }
const _hoisted_12 = { class: "w-full upperspacing" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_16 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_17 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_24 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_29 = {
  key: 1,
  class: "w-6/12 leftspacing"
}
const _hoisted_30 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_31 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_32 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_33 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_34 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_35 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_36 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_37 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_38 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_39 = { class: "w-full leftspacing" }
const _hoisted_40 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_41 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_42 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_43 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_44 = {
  key: 0,
  class: "w-full"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", { class: "title" }, "Information")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importDoc()))
        }, "Import"),
        (_ctx.pageType)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btnprimary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoInfoMapping()))
            }, "Map"))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          class: "hidden",
          accept: ".xls,.xlsx",
          ref: "file",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fileReader($event)))
        }, null, 544),
        _createElementVNode("button", {
          class: "btnprimary flex items-center",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showInformationPopup && _ctx.showInformationPopup(...args)))
        }, "Add"),
        _createElementVNode("button", {
          class: _normalizeClass(["flex", _ctx.tableRow.length == 0?'btndisabled pointer-events-none':'filterButton']),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.tableRow.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[25] || (_cache[25] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
      _createElementVNode("div", null, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headersRoot,
        navigate: true,
        openPopup: false,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.showUserModal)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showUserModal
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _cache[28] || (_cache[28] = _createElementVNode("h1", null, "Information", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.onCancelbtn();
                                this.showUserModal = false;
                            })
                }, _cache[27] || (_cache[27] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                          _createElementVNode("div", null, [
                            (_ctx.pageType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.information.informationCategory,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                                    suggestions: _ctx.filteredCategories,
                                    onComplete: _ctx.searchCategory,
                                    placeholder: "Information Category",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                    'is-invalidmultiselect': _ctx.v$.information.informationCategory.$error,
                                                    'has-options': _ctx.filteredCategories && _ctx.filteredCategories.length > 0,
                                                    'no-options':  !_ctx.filteredCategories.length,
                                                }])
                                  }, {
                                    empty: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.information.informationCategory,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                                    suggestions: _ctx.subInfoCategoryList,
                                    onComplete: _ctx.asyncCategoryFind,
                                    placeholder: "Information Category",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                    'p-invalid': _ctx.v$.information.informationCategory.$error,
                                                    'has-options': _ctx.subInfoCategoryList && _ctx.subInfoCategoryList.length > 0,
                                                    'no-options': !_ctx.subInfoCategoryList.length &&  _ctx.searchValue !== '',
                                                }])
                                  }, {
                                    empty: _withCtx(() => _cache[30] || (_cache[30] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "class"])
                                ])),
                            (_ctx.v$.information.informationCategory.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (_ctx.v$.information.informationCategory.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                            _createElementVNode("div", null, [
                              (_ctx.pageType)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.information.information,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.information.information) = $event)),
                                      suggestions: _ctx.filteredInformation,
                                      onComplete: _ctx.searchInformation,
                                      disabled: _ctx.information.informationCategory=='',
                                      placeholder: "Information",
                                      field: "label",
                                      class: _normalizeClass(["w-full", {
                                                    'is-invalidmultiselect': _ctx.v$.information.information.$error,
                                                    'has-options': _ctx.filteredInformation && _ctx.filteredInformation.length > 0,
                                                    'no-options':  !_ctx.filteredInformation.length,
                                                }])
                                    }, {
                                      empty: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Information Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.information.information,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.information.information) = $event)),
                                      suggestions: _ctx.subInfoList,
                                      onComplete: _ctx.asyncInformationFind,
                                      disabled: _ctx.information.informationCategory=='',
                                      placeholder: "Information",
                                      field: "label",
                                      class: _normalizeClass(["w-full", {
                                                    'p-invalid': _ctx.v$.information.information.$error,
                                                    'has-options': _ctx.subInfoList && _ctx.subInfoList.length > 0,
                                                    'no-options': !_ctx.subInfoList.length &&  _ctx.searchValue !== '',
                                                }])
                                    }, {
                                      empty: _withCtx(() => _cache[33] || (_cache[33] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Information Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                                  ])),
                              (_ctx.v$.information.information.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (_ctx.v$.information.information.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (_ctx.pageType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.information.informationOwner,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.information.informationOwner) = $event)),
                                  suggestions: _ctx.userOptions,
                                  onComplete: _ctx.asyncFind,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  forceSelection: true,
                                  placeholder: "Info Owner",
                                  class: _normalizeClass(["p-inputtext-sm systemsstyling w-full", {
                                                'p-invalid': _ctx.v$.information.informationOwner.$error,
                                                'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                                }])
                                }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                (_ctx.v$.information.informationOwner.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      (_ctx.v$.information.informationOwner.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", _ctx.pageType ? 'leftspacing' : ''])
                          }, [
                            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.confidentiality,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.information.confidentiality) = $event)),
                              options: _ctx.dbConfidentiality,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                'is-invalid': _ctx.v$.information.confidentiality.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.information.confidentiality === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.information.confidentiality !== ''
                                            }]),
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getMaxIdValue()))
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.information.confidentiality.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_ctx.v$.information.confidentiality.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (!_ctx.pageType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.information.integrity,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.information.integrity) = $event)),
                                  options: _ctx.dbIntegrity,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                'is-invalid': _ctx.v$.information.integrity.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.information.integrity === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.information.integrity !== ''  
                                            }]),
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getMaxIdValue()))
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.information.integrity.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      (_ctx.v$.information.integrity.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          (_ctx.pageType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.information.integrity,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.information.integrity) = $event)),
                                  options: _ctx.dbIntegrity,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                'is-invalid': _ctx.v$.information.integrity.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.information.integrity === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.information.integrity !== ''  
                                            }]),
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getMaxIdValue()))
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.information.integrity.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      (_ctx.v$.information.integrity.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", _ctx.pageType ? 'leftspacing' : ''])
                          }, [
                            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.availability,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.information.availability) = $event)),
                              options: _ctx.dbAvailability,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getMaxIdValue())),
                              class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                    'is-invalid': _ctx.v$.information.availability.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.information.availability === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.information.availability !== ''    
                                                }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.information.availability.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  (_ctx.v$.information.availability.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (!_ctx.pageType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.information.classification,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.information.classification) = $event)),
                                    options: _ctx.dbInformationClassification,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.getMaxIdValue())),
                                    class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                    'is-invalid': _ctx.v$.information.classification.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.information.classification === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.information.classification !== ''    
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.information.classification.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        (_ctx.v$.information.classification.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          (_ctx.pageType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (_ctx.information.classification != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classificationSelect, (dataValue, indexNum) => {
                                        return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                          (_ctx.information.classification == dataValue.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "text",
                                                  class: "disabledinputboxstyling",
                                                  disabled: "",
                                                  "onUpdate:modelValue": ($event: any) => ((dataValue.status) = $event),
                                                  placeholder: "Classification"
                                                }, null, 8, _hoisted_46), [
                                                  [_vModelText, dataValue.status]
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_47, [
                                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.information.classification,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.information.classification) = $event)),
                                    options: _ctx.dbInformationClassification,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                    'is-invalid': _ctx.v$.information.classification.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.information.classification === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.information.classification !== ''  
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.information.classification.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        (_ctx.v$.information.classification.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.information.securityCategory != '')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["w-6/12", _ctx.pageType ? 'leftspacing' : ''])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (dataValue, indexNum) => {
                                  return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                    (_ctx.information.securityCategory == dataValue.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _cache[43] || (_cache[43] = _createElementVNode("label", { class: "controllabel" }, "Security Category", -1)),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "disabledinputboxstyling",
                                            disabled: "",
                                            "onUpdate:modelValue": ($event: any) => ((dataValue.key) = $event),
                                            placeholder: "Security Category"
                                          }, null, 8, _hoisted_51), [
                                            [_vModelText, dataValue.key]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("button", {
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onCancelbtn(_ctx.information)))
                    }, "Reset", 10, _hoisted_53),
                    (!_ctx.information._id)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addOrUpdateInformation())),
                          class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                        }, "Save", 10, _hoisted_54))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          disabled: _ctx.clickOnButton,
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addOrUpdateInformation(_ctx.information)))
                        }, "Update", 10, _hoisted_55))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}